/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_404_TitleInputs */

const en_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page not found`)
};

const es_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página no encontrada`)
};

const de_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite nicht gefunden`)
};

const zh_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找不到页面`)
};

const ar_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة غير موجودة`)
};

const fr_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page introuvable`)
};

const vi_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy trang`)
};

const sw_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukurasa haujapatikana`)
};

const th_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบหน้า`)
};

const bs_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stranica nije pronađena`)
};

const ja_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページが見つかりませんでした`)
};

const ko_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사이트 맵`)
};

const pt_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página não encontrada`)
};

const it_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina non trovata`)
};

const sv_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidan hittades inte`)
};

const nl_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina niet gevonden`)
};

const da_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side ikke fundet`)
};

const nb_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side ikke funnet`)
};

const fi_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivua ei löytynyt`)
};

const pl_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono strony`)
};

const ru_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница не найдена`)
};

const tr_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa bulunamadı`)
};

const hi_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं मिला`)
};

const id_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tak ditemukan`)
};

const ms_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman tidak dijumpai`)
};

const cs_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stránka nenalezena`)
};

const el_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η σελίδα δε βρέθηκε`)
};

const he_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דף לא נמצא`)
};

const af_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bladsy nie gevind nie`)
};

const hu_error_404_title = /** @type {(inputs: Error_404_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oldal nem található`)
};

/**
* | output |
* | --- |
* | "Page not found" |
*
* @param {Error_404_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const error_404_title = /** @type {((inputs?: Error_404_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_404_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_error_404_title(inputs)
	if (locale === "de") return de_error_404_title(inputs)
	if (locale === "zh") return zh_error_404_title(inputs)
	if (locale === "ar") return ar_error_404_title(inputs)
	if (locale === "fr") return fr_error_404_title(inputs)
	if (locale === "vi") return vi_error_404_title(inputs)
	if (locale === "sw") return sw_error_404_title(inputs)
	if (locale === "th") return th_error_404_title(inputs)
	if (locale === "bs") return bs_error_404_title(inputs)
	if (locale === "ja") return ja_error_404_title(inputs)
	if (locale === "ko") return ko_error_404_title(inputs)
	if (locale === "pt") return pt_error_404_title(inputs)
	if (locale === "it") return it_error_404_title(inputs)
	if (locale === "sv") return sv_error_404_title(inputs)
	if (locale === "nl") return nl_error_404_title(inputs)
	if (locale === "da") return da_error_404_title(inputs)
	if (locale === "nb") return nb_error_404_title(inputs)
	if (locale === "fi") return fi_error_404_title(inputs)
	if (locale === "pl") return pl_error_404_title(inputs)
	if (locale === "ru") return ru_error_404_title(inputs)
	if (locale === "tr") return tr_error_404_title(inputs)
	if (locale === "hi") return hi_error_404_title(inputs)
	if (locale === "id") return id_error_404_title(inputs)
	if (locale === "ms") return ms_error_404_title(inputs)
	if (locale === "cs") return cs_error_404_title(inputs)
	if (locale === "el") return el_error_404_title(inputs)
	if (locale === "he") return he_error_404_title(inputs)
	if (locale === "af") return af_error_404_title(inputs)
	if (locale === "hu") return hu_error_404_title(inputs)
	return en_error_404_title(inputs)
});